import { Helper } from '../../helpers/Helper';

/**
 * OverflowHidden Class
 */
export class OverflowHidden {

	/**
	 * Constructor
	 *
	 * @param {string} containerEl
	 * @return {void}
	 */
	constructor( containerEl ) {

		this.allBlocks = document.querySelectorAll( containerEl );
		if ( ! this.allBlocks || this.allBlocks.length === 0 ) {

			return false;

		}
		this.wpSiteBlocks = document.querySelector( '.wp-site-blocks main' );

		this.init();

	}

	/**
	 * Init
	 *
	 * @return {void}
	 */
	init(){

		if ( this.allBlocks.length > 0 ) {

			this.allBlocks.forEach( ( block ) => {

				const hasPositionAbsolute = block.querySelector( '.has-position-absolute' );
				if ( hasPositionAbsolute && this.wpSiteBlocks ){

					Helper.addClassToEl( this.wpSiteBlocks, 'js-overflow-hidden' );

				}

			} );

		}

	}

}
